import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationDataService {
  private data: any = null;

  setData(data: any): void {
    this.data = data;
  }

  getData(): any {
    const temp = this.data;
    this.data = null;
    return temp;
  }

  clearData(): void {
    this.data = null;
  }
}
